import React from 'react';

const InterestChip = props => {
    return (
        <div className="interest-chip">
            <p className="interest-chip__label">{props.value}</p>
            <button className="interest-chip__btn" onClick={props.clicked}><i className="fa fa-times"></i></button>
        </div>
    )
}

export default InterestChip;